var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5466,
    cy: 19.5466,
    r: 19.5466,
    fill: "#CB8B65"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7875 11.2305H12.7875C12.257 11.2305 11.7483 11.4412 11.3733 11.8163C10.9982 12.1913 10.7875 12.7 10.7875 13.2305V27.2305C10.7875 27.7609 10.9982 28.2696 11.3733 28.6447C11.7483 29.0198 12.257 29.2305 12.7875 29.2305H26.7875C27.3179 29.2305 27.8266 29.0198 28.2017 28.6447C28.5768 28.2696 28.7875 27.7609 28.7875 27.2305V20.2305",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1625 10.8557C26.5603 10.4579 27.0999 10.2344 27.6625 10.2344C28.2251 10.2344 28.7647 10.4579 29.1625 10.8557C29.5603 11.2535 29.7838 11.7931 29.7838 12.3557C29.7838 12.9183 29.5603 13.4579 29.1625 13.8557L19.7875 23.2307L15.7875 24.2307L16.7875 20.2307L26.1625 10.8557Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.ea02b601c84ac98ae16602f0d9e0304a.svg";
export { ForwardRef as ReactComponent };